import React, { useEffect, useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, Grid } from '@mui/material';
import apiInstance from '../../services/ServiceApi';

const LineaNegocio = ({onLineaChange }) => {
    const [empresas, setEmpresas] = useState([]);
    const [lineas, setLineas] = useState([]);
    const [selectedEmpresa, setSelectedEmpresa] = useState('');
    const [selectedLinea, setSelectedLinea] = useState('');
    
    useEffect(() => {
      apiInstance.get('lineasnegocio/')
        .then(response => {
          setEmpresas([...new Set(response.data.map(item => item.empresa_nombre))]);
          setLineas(response.data);
        })
        .catch(error => console.error('Error:', error));
    }, []);
  
    const handleEmpresaChange = (event) => {
      setSelectedEmpresa(event.target.value);
      setSelectedLinea('');
    };
  
    const handleLineaChange = (event) => {
        const selectedLinea = lineas.find(linea => linea.linea_negocio === event.target.value);
        if (selectedLinea) {
          setSelectedLinea(selectedLinea.linea_negocio);
          onLineaChange(selectedLinea);
        } else {
          console.error('Línea de negocio seleccionada no encontrada:', event.target.value);
        }
      };
      
    return (
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Empresa</InputLabel>
              <Select value={selectedEmpresa} onChange={handleEmpresaChange} variant="outlined"  label="Empresa">

                {empresas.map((empresa, index) => (
                  <MenuItem key={index} value={empresa}>{empresa}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl fullWidth>
              <InputLabel>Línea de Negocio</InputLabel>
              <Select value={selectedLinea} onChange={handleLineaChange} label="Línea de Negocio">
                {lineas.filter(linea => linea.empresa_nombre === selectedEmpresa).map((linea, index) => (
                  <MenuItem key={index} value={linea.linea_negocio}>{linea.linea_negocio}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
    );
}

export default LineaNegocio;
